import styled from 'styled-components';

const ImgWrapperStyled = styled.div`
  ${(props) => {
    if (props.aspectRatio) {
      return `
        padding-top: ${props.aspectRatio}%;
        width: 100%;
        position: relative;
        overflow: hidden;

        img {
          position: absolute;
          top: 0;
          width: auto;
        }
      `;
    }
    return '';
  }}

  img {
    height: auto;
    width: 100%;
  }
`;

const ImgWrapper = (props) => {
  const { imageSrc, imageAlt, aspectRatio } = props;

  return (
    <ImgWrapperStyled
      aspectRatio={aspectRatio}
      className={`img-wrapper ${aspectRatio && 'aspect-ratio'}`}
    >
      <img src={imageSrc} alt={imageAlt} />
    </ImgWrapperStyled>
  );
};

export default ImgWrapper;
